import React from 'react'

import { useForm } from './_load/FormLoader'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const ResumePageHeader = () => {
  const navigate = useNavigation()
  const form = useForm()

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/forms/${form.id}/form-replies`)}
      title={form.name}
      mediumPadding
      noContainer
    />
  )
}

export default ResumePageHeader
